var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 402.144,
    height: 466,
    viewBox: "0 0 402.144 466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "moon",
    x: 0,
    y: 0,
    width: 402.144,
    height: 466,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#moon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "moon-2",
    "data-name": "moon",
    d: "M223.5,32C100,32,0,132.3,0,256S100,480,223.5,480a222.714,222.714,0,0,0,155.8-63.4,15.984,15.984,0,0,0-13.9-27.2,175.5,175.5,0,0,1-30.1,2.6c-96.9,0-175.5-78.8-175.5-176A175.955,175.955,0,0,1,249.1,62.7a15.972,15.972,0,0,0-6.6-29.8c-6.3-.5-12.6-.8-19-.8Z",
    transform: "translate(6 -27)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.2561b50df89c3c4db4b7814c45995e0f.svg";
export { ForwardRef as ReactComponent };